import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityTypes} from '@catmodels/linked-entities/types';
import {DisplayTypes} from '@catui/components/panel/types';
import {LinkItem} from '@catui/types';

@Component({
  selector: 'cat-linked-entities',
  templateUrl: './linked-entities.component.html',
  styleUrls: ['./linked-entities.component.scss'],
})
export class LinkedEntitiesComponent implements OnInit {

  @Input() title: string = null;
  @Input() noItemPlaceholder = 'No items';
  @Input() entityType = EntityTypes.Default;
  @Input() featureLevel = true;

  @Input() set linkedEntityUris(value: Array<{ href: string }>) {
    this._linkedEntityUris = value;
  }

  get linkedEntityUris() {
    return this._linkedEntityUris;
  }

  PanelDisplayTypes = DisplayTypes;

  _linkedEntityUris: Array<{href: string }> = [];

  constructor(private routerService: Router) { }

  ngOnInit() {
  }

  /**
   * Callback to execute the navigation process for a manually triggered LinkItem
   * @param {LinkItem} item
   */
  navigateTo(item: LinkItem) {
    item.navigate(this.routerService);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/linked-entities/components/linked-entities/linked-entities.component.ts